import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_activity_registration_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  activity_guid: fromDatatype.GuidDataFieldInterface;
  app_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  phone_number: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_activity_registration_RowClass implements bl_crm_activity_registration_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  activity_guid: fromDatatype.GuidDataFieldInterface;
  app_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  phone_number: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


